class StringHelper {
  /**
   * This method will pluralize the given word
   * @param {string} word
   * @returns {string}
   */
  static pluralize(word) {
    const loweredWord = word.toLowerCase();
    //Only a consonant + y becomes ies (company -> companies), a vowel + y just gets an s (day -> days)
    if (/[^aeiou]y$/.test(loweredWord)) {
      return word.slice(0, -1) + "ies";
    } else if (loweredWord.endsWith("s")) {
      return word + "es";
    }
    return word + "s";
  }

  /**
   * This method will normalize the given text for searching, by making it lowercase and removing accents (ë -> e, É -> e)
   * @param {any} text
   * @returns {string}
   */
  static normalizeForSearch(text) {
    //Split accented letters into the letter and its accent (NFD), then remove the accents
    return `${text ?? ""}`
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase();
  }

  /**
   * This method will check if the given text contains the given search, ignoring case and accents.
   * For example, "Zoë" matches the search "zoe", and "Zoe" matches the search "zoë".
   * @param {any} text
   * @param {string} search
   * @returns {boolean}
   */
  static matchesSearch(text, search) {
    return StringHelper.normalizeForSearch(text).includes(
      StringHelper.normalizeForSearch(search),
    );
  }
}

export default StringHelper;
